var map = {
	"./icon-add-audio.svg": "d73c",
	"./icon-add-file.svg": "a1ab",
	"./icon-add-image.svg": "d3ff",
	"./icon-add-video.svg": "8b38",
	"./icon-add.svg": "40e7",
	"./icon-briefcase.svg": "a163",
	"./icon-close.svg": "c7ff",
	"./icon-date.svg": "9313",
	"./icon-envelope.svg": "ae43",
	"./icon-hamburger.svg": "e1b2",
	"./icon-home.svg": "81ac",
	"./icon-ios-action.svg": "a5ac",
	"./icon-ios-action2.svg": "3656",
	"./icon-ios-add.svg": "d4d7",
	"./icon-listen.svg": "ed6f3",
	"./icon-lock.svg": "df85",
	"./icon-message.svg": "abd2",
	"./icon-missed.svg": "394d",
	"./icon-moving-circle.svg": "da00",
	"./icon-paperclip.svg": "aac6",
	"./icon-person.svg": "b576",
	"./icon-placeholder-1.svg": "8fa7",
	"./icon-placeholder.svg": "a99d",
	"./icon-profile.svg": "bc64",
	"./icon-tag.svg": "4d32",
	"./icon-watch.svg": "353d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f8b9";